import { css } from 'lit';

export const dividerBlockStyles = css`
  .hive-divider-block-container {
    position: relative;
    width: 100%;
    height: 1px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 18px 8px;
    margin-top: var(--hive-paragraph-space);
  }
  .hive-divider-block-container hr {
    border: none;
    border-top: 1px solid var(--hive-divider-color);
    width: 100%;
  }
`;
